var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogleMar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 61,
    viewBox: "0 0 61 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.0141 42.0264C34.3544 40.3666 34.3544 37.674 36.0141 36.0127C32.6931 39.3337 27.3093 39.3337 23.9882 36.0127C25.648 37.6725 25.648 40.3651 23.9882 42.0264C22.3285 43.6862 19.6358 43.6862 17.9745 42.0264C24.6062 48.658 35.3962 48.658 42.0278 42.0264C40.3666 43.6862 37.6739 43.6862 36.0141 42.0264Z",
    fill: "#FBBC04"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0271 17.9727C35.3955 11.3411 24.6054 11.3411 17.9738 17.9727C11.3422 24.6044 11.3422 35.3944 17.9738 42.026C16.314 40.3663 16.314 37.6736 17.9738 36.0123C19.6336 34.3526 22.3262 34.3526 23.9875 36.0123C20.6665 32.6913 20.6665 27.3075 23.9875 23.9864C27.3086 20.6654 32.6924 20.6654 36.0134 23.9864C37.6732 25.6462 40.3658 25.6462 42.0271 23.9864C43.6869 22.3252 43.6869 19.634 42.0271 17.9727Z",
    fill: "#4184F3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9805 43.2715C23.329 43.2715 25.2329 41.3676 25.2329 39.019C25.2329 36.6705 23.329 34.7666 20.9805 34.7666C18.6319 34.7666 16.728 36.6705 16.728 39.019C16.728 41.3676 18.6319 43.2715 20.9805 43.2715Z",
    fill: "#34A853"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0277 17.9734C43.6875 19.6332 43.6875 22.3258 42.0277 23.9871C40.3679 25.6469 37.6753 25.6469 36.014 23.9871C39.335 27.3081 39.335 32.6919 36.014 36.013C34.3542 37.6728 34.3542 40.3654 36.014 42.0267C37.6738 43.6865 40.3664 43.6865 42.0277 42.0267C48.6578 35.395 48.6578 24.605 42.0277 17.9734Z",
    fill: "#EA4335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleMar);
export default __webpack_public_path__ + "static/media/google-mar.67b7fb8bf209896d83276687cdc413ca.svg";
export { ForwardRef as ReactComponent };